module.exports = __webpack_public_path__ + "img/tiktok.8bbdc548.svg";